import Swiper, { Autoplay, Navigation, EffectCreative } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';

let similarInsightsSwiperWr = document.querySelectorAll('.similar-insights-swiper-wr');

similarInsightsSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let parentEl = el.parentElement;
    let nextEl = parentEl.querySelector('.swiper-button-next');
    let prevEl = parentEl.querySelector('.swiper-button-prev');
    const slidesCount = swiperEl.querySelectorAll('.swiper-slide').length;

    const isBlockedSwipe = window.innerWidth > 1150 && slidesCount <= 2;

    let autoplay = {
      delay: 4000,
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
    }

    if(isBlockedSwipe) {
      autoplay = false;
    }

    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation, EffectCreative],
      slidesPerView: 1,
      spaceBetween: 0,
      threshold: 10,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      observer: true,
      observeParents: true,
      allowTouchMove: !isBlockedSwipe,
      navigation: {
        nextEl,
        prevEl,
      },
      autoplay: autoplay,
      effect: 'creative',
      creativeEffect: {
        limitProgress: 2,
        next: {
          translate: ['calc(100% + 20px)', 0, 0],
          opacity: 1,
          scale: 1,
        },
        prev: {
          opacity: 0,
          translate: [0, '40%', 0],
        },
      },
    });

    if(!isBlockedSwipe) {
      swiperObserver(swiper);
    }
  }
});